import React from 'react';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { freeBetStore, isMobile, notificationStore } from '@pascal/pascal-core';
import { AdditionalInputValueChangingButtons } from '@pascal/pascal-core/shared/core/enums/additionalInputValueChangingButtons';
import { observer } from 'mobx-react-lite';
import { marketsStore } from '../../../../store';
import { betAmountValidator } from '../../../../helpers/supporters';
import { numPadSectionName } from '../../../../enums';

const BetInputForMarkets = observer(
  ({ handleOpenNumPad, setIsValidatedAmount, isMarketSection, handleChangeInputValue }) => {
    const { limits } = gameConfigStore;
    const { currentMarketAmount = limits.minBet, isDisabledMarketsSection } = marketsStore;
    const { activeFreeBet } = freeBetStore;

    const onBlur = () => {
      const { validatedBetAmount, errorMessageCode } = betAmountValidator(
        currentMarketAmount,
        limits
      );
      if (errorMessageCode) {
        notificationStore.setNotificationType({ responseCode: errorMessageCode });
        setIsValidatedAmount(true);
      }
      marketsStore.changeCurrentMarketAmount(validatedBetAmount);
    };

    return (
      <>
        <div
          className={`bet-section-left ${
            activeFreeBet?.id || (isMarketSection && isDisabledMarketsSection) ? 'passive' : ''
          }`}
        >
          <button
            type='button'
            className='bet-section-action'
            onClick={() => {
              handleChangeInputValue(AdditionalInputValueChangingButtons.divide);
            }}
          >
            <span>1/2</span>
          </button>
          <div className='bet-section-calc'>
            <div className='bet-section-calc-inner'>
              <button
                type='button'
                className='bet-section-counter'
                onClick={() => {
                  handleChangeInputValue(AdditionalInputValueChangingButtons.minus);
                }}
              >
                <i className='ui-lib-minus' />
              </button>
              <input
                className='bet-section-input'
                type='text'
                readOnly={isMobile()}
                maxLength={9}
                onBlur={onBlur}
                inputMode={isMobile() ? 'none' : 'text'}
                value={currentMarketAmount || ''}
                title={currentMarketAmount || ''}
                disabled={isDisabledMarketsSection}
                onClick={(e) => handleOpenNumPad(e, numPadSectionName.markets)}
                onChange={(e) => {
                  if (
                    /^([0]{1}|([1-9]{1}\d*))(?:\.\d{0,2})?$/.test(e.target.value) ||
                    e.target.value === ''
                  ) {
                    marketsStore.changeCurrentMarketAmount(e.target.value.replace(',', '.'));
                  }
                }}
                {...(isMobile()
                  ? { onClick: (e) => handleOpenNumPad(e, numPadSectionName.markets) }
                  : {})}
              />
              <button
                type='button'
                className='bet-section-counter'
                onClick={() => {
                  handleChangeInputValue(AdditionalInputValueChangingButtons.plus);
                }}
              >
                <i className='ui-lib-plus' />
              </button>
            </div>
          </div>
          <button
            type='button'
            className='bet-section-action'
            onClick={() => {
              handleChangeInputValue(AdditionalInputValueChangingButtons.multiply);
            }}
          >
            <span>x2</span>
          </button>
        </div>
        {/* <div */}
        {/*  className={`bet-btn-left-inner ${ */}
        {/*    activeFreeBet?.id || (isMarketSection && isDisabledMarketsSection) ? 'passive' : '' */}
        {/*  }`} */}
        {/* > */}
        {/*  <div */}
        {/*    className='bet-btn-left-inp-sq' */}
        {/*    onClick={() => { */}
        {/*      handleChangeInputValue(AdditionalInputValueChangingButtons.divide); */}
        {/*      // decidedCallBackCall(() => */}
        {/*      //   changeBetInputValue(additionalBetAmountChangingButtons.divide) */}
        {/*      // ); */}
        {/*    }} */}
        {/*    title={'1/2'} */}
        {/*  > */}
        {/*    <div className='odd-g-inp-square-block'> */}
        {/*      <span>1/2</span> */}
        {/*    </div> */}
        {/*  </div> */}
        {/*  <div className='bet-btn-left-inp'> */}
        {/*    <div className='odd-g-inp-content-inner mid'> */}
        {/*      <div */}
        {/*        className='odd-inp-content-square left' */}
        {/*        onClick={() => { */}
        {/*          handleChangeInputValue(AdditionalInputValueChangingButtons.minus); */}
        {/*          // decidedCallBackCall(() => */}
        {/*          //   changeBetInputValue(additionalBetAmountChangingButtons.minus) */}
        {/*          // ); */}
        {/*        }} */}
        {/*      > */}
        {/*        <div className='odd-g-inp-square-block-min '> */}
        {/*          <i className='icon-minus'/> */}
        {/*        </div> */}
        {/*      </div> */}
        {/*      <input */}
        {/*        type='text' */}
        {/*        readOnly={isMobile()} */}
        {/*        maxLength={9} */}
        {/*        onBlur={onBlur} */}
        {/*        inputMode={isMobile() ? 'none' : 'text'} */}
        {/*        className='odd-g-inp-content-input' */}
        {/*        value={currentMarketAmount || ''} */}
        {/*        title={currentMarketAmount || ''} */}
        {/*        disabled={isDisabledMarketsSection} */}
        {/*        onClick={(e) => handleOpenNumPad(e, numPadSectionName.markets)} */}
        {/*        onChange={(e) => { */}
        {/*          if (!/^[.,]/.test(e.target.value) && /^\d*[.,]?\d*$/.test(e.target.value)) { */}
        {/*            marketsStore.changeCurrentMarketAmount(e.target.value.replace(',', '.')); */}
        {/*          } */}
        {/*        }} */}
        {/*        {...(isMobile() */}
        {/*          ? {onClick: (e) => handleOpenNumPad(e, numPadSectionName.markets)} */}
        {/*          : {})} */}
        {/*      /> */}
        {/*      <div */}
        {/*        className='odd-inp-content-square right' */}
        {/*        onClick={() => { */}
        {/*          handleChangeInputValue(AdditionalInputValueChangingButtons.plus); */}

        {/*          // decidedCallBackCall(() => */}
        {/*          //   changeBetInputValue(additionalBetAmountChangingButtons.plus) */}
        {/*          // ); */}
        {/*        }} */}
        {/*      > */}
        {/*        <div className='odd-g-inp-square-block-min '> */}
        {/*          <i className='icon-plus'/> */}
        {/*        </div> */}
        {/*      </div> */}
        {/*    </div> */}
        {/*  </div> */}
        {/*  <div */}
        {/*    className='bet-btn-left-inp-sq' */}
        {/*    onClick={() => { */}
        {/*      handleChangeInputValue(AdditionalInputValueChangingButtons.multiply); */}

        {/*      // decidedCallBackCall(() => */}
        {/*      //   changeBetInputValue(additionalBetAmountChangingButtons.double) */}
        {/*      // ); */}
        {/*    }} */}
        {/*    title={'x2'} */}
        {/*  > */}
        {/*    <div className='odd-g-inp-square-block'> */}
        {/*      <span>x2</span> */}
        {/*    </div> */}
        {/*  </div> */}
        {/* </div> */}
      </>
    );
  }
);
export default BetInputForMarkets;
